import "./styles.css"

import React, { Component } from 'react'
import { connect } from 'react-redux'

import MasterDetailLayout from 'components/MasterDetailLayout'
import Header from 'components/Header'
import AddButton from 'components/AddButton'
import Hamburger from 'components/Hamburger'
import PropertiesList from './List'
import PropertiesTable from './Table'
import PropertyForm from '../propertyForm'

import FiltersPicker from 'components/FiltersPicker'
import Notifications from 'components/ListLayoutParts/Notifications'

import dataActions from 'actions/dataActions'
import filtersActions from 'actions/filters'
import moment from 'moment'
import Search from 'components/Search'

let select = (state) => state

export class PropertiesPage extends Component {
	render() {
		let { props } = this
		let detailID = props.routeParams.id
		let currentFilter = (props.filters && props.filters.property)? props.filters.property.value : -1
		let header = (style) => (
			<Header {...{style}}>
				<Hamburger />
				<div>
					<FiltersPicker entity={'property'} />
					<Notifications />
					<div style={{
							float: "right"
						  , position: "relative"
						  , top: "-24px"
						  , left: "240px"}}
					>
						<Search  entity={'property'} id="search-properties" style={{marginTop: "-8px"}}/><
					/div>
				</div>
				<AddButton object={{type:'property', dateFrom: moment(new Date()).format("YYYY-MM-DD")}} color="#FFF" detailID={detailID}/>
			</Header>
		)
		return(
			<MasterDetailLayout
				header={header}
				master={props => <PropertiesTable {...props} detailID={detailID} />}
				detail={props => <PropertyForm {...props} id={detailID} />}
				detailColumns={2}
				detailOpen={!!detailID}
			/>
		)
	}
}

export default connect(select, dataActions)(PropertiesPage)
// PropertiesPage
// let header = <ListHeader type="property" id={props.routeParams.id} />
// OR
// let header = (style) => (
// 	<Header {...{style}}>
// 		<Hamburger />
// 		<Filters type="property" />
// 		<MenuButton>
// 			<MenuItem onClick={props.NEW("bill")}>
// 				Add Bill
// 			</MenuItem>
// 			<MenuItem onClick={props.NEW("invoice")}>
// 				Add Invoice
// 			</MenuItem>
// 			<Divider />
// 			<MenuItem onClick={props.COPY(props.routeParams.id)}>
// 				Copy
// 			</MenuItem>
// 		</MenuButton>
// 	</Header>
// )
//OR
// let commands = [{name: "ADD BILL", action:() => props.NEW(props.type)}, {name: "COPY", action: () => props.COPY(props.routeParams.id) }]
// let header = (
// 	<ListHeader commands={commands} >
// 		<Omnibox />
// 	</ListHeader>
// )
// let detailID = props.routeParams.id
// <MasterDetailLayout
// 	header={header}
// 	master={(style) => (<PropertiesList {...{style}}/>)}
// 	detail={(style) => (<PropertyForm {...{style}} id={detailID} />)}
// 	detailColumns={2}
// 	detailOpen={!!detailID}
// />



// WEBPACK FOOTER //
// ./src/routes/manager/properties/index.js